import React from 'react';
import { WidgetNotAvailable } from 'widgets/WidgetNotAvailable/WidgetNotAvailable';

export function WidgetPermissionDenied() {
    return (
        <WidgetNotAvailable
            className="widget-permission-denied"
            title={'You are not enabled to view this widget.'}
        />
    );
}
